import { render, staticRenderFns } from "./ShiCiSearch.vue?vue&type=template&id=5aa88745&scoped=true&"
import script from "./ShiCiSearch.vue?vue&type=script&lang=js&"
export * from "./ShiCiSearch.vue?vue&type=script&lang=js&"
import style0 from "./ShiCiSearch.vue?vue&type=style&index=0&id=5aa88745&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa88745",
  null
  
)

export default component.exports